export const stepOneData = [
  {
    heading: "Understanding Car Loan Eligibility",
    // paras before heading
    paraOne:
      "Car loan eligibility can vary significantly depending on the lender and the type of vehicle you're financing. Here’s what you need to know:",

    contentHeadOne: "1. FOIR vs. Multiplier-Based Method:",
    contentParaOne:
      "Some lenders use the Fixed Obligations to Income Ratio (FOIR) method, which evaluates the percentage of your income already committed to existing EMIs. A FOIR below 50% is generally preferred.",
    contentParaTwo:
      "Other lenders rely on the Multiplier Method, where your annual income is multiplied by a fixed factor (e.g., 3-6 times) to calculate the maximum loan amount.",

    contentHeadTwo: "2. Loan-to-Value (LTV) Ratio:",
    contentTwoList: [
      {
        head: "New Car Loans: ",
        info: "Lenders usually offer up to 90-100% of the car's ex-showroom price.",
      },
      {
        head: "Used Car Loans: ",
        info: "The LTV for pre-owned vehicles is typically lower, often capped at 70-80% of the car's current market value.",
      },
    ],

    contentHeadThree: "3. New vs. Used Cars:",
    contentThreeList: [
      {
        head: "New Car Loans: ",
        info: "These have more relaxed eligibility criteria, lower interest rates, and higher LTV ratios.",
      },
      {
        head: "Used Car Loans: ",
        info: "These involve higher interest rates and stricter conditions due to vehicle depreciation and limited resale value.",
      },
    ],
  },
];

export const stepTwoData = [
  {
    heading: "Factors That Impact Car Loan Eligibility",
    subtitle: "Several factors determine your car loan eligibility:",
    factorsList: [
      {
        head: "Income Stability: ",
        info: "A higher and stable income increases your chances of approval.",
      },
      {
        head: "Existing Debt: ",
        info: "Fewer ongoing EMIs result in a better FOIR, improving your eligibility.",
      },
      {
        head: "Credit Score: ",
        info: "A credit score above 700 is ideal for securing favorable car loan offers.",
      },
      {
        head: "Tenure Preference: ",
        info: "Longer loan tenures enhance eligibility but may increase overall interest costs.",
      },
      {
        head: "Down Payment: ",
        info: "Making a larger down payment lowers the loan amount, improving eligibility.",
      },
    ],

    tip: "Tips for Using Minemi’s Car Loan Eligibility Calculator",
    tipSubtitle:
      "Maximize the value of Minemi’s calculator by following these simple tips:",
    improveEligibilityList: [
      {
        head: "Accurate Income Details: ",
        info: "Input your total monthly or annual income correctly, including any additional income sources.",
      },
      {
        head: " List Existing EMIs: ",
        info: "Include ongoing loan repayments for precise FOIR calculations",
      },
      {
        head: "Select the Correct Loan Type: ",
        info: "Specify if you're applying for a new car or a used car loan to get tailored results.",
      },
      {
        head: "Adjust Loan Tenure and Down Payment: ",
        info: "Experiment with these variables to find the best combination for your budget and eligibility.",
      },
      {
        head: "Input the Vehicle Value: ",
        info: "Use the car's ex-showroom price for new vehicles or the estimated market value for used cars.",
      },
      {
        head: "Understand the Results: ",
        info: "Review the insights provided by the calculator and follow the tips to enhance your eligibility.",
      },
    ],
  },
];

export const stepThreeData = [
  {
    heading: "How Minemi Simplifies Car Loans",
    subtitle:
      "Minemi’s Car Loan Eligibility Calculator goes beyond simple calculations. Here’s how it helps:",

    eligibilityList: [
      {
        info: "Provides tailored eligibility results based on lender-specific criteria.",
      },
      {
        info: "Offers insights into improving eligibility, such as reducing FOIR or making a higher down payment.",
      },
      {
        info: "Helps you compare options for new and used cars with actionable recommendations.",
      },
    ],
  },
];

export const stepFourData = [
  {
    heading: "How to Use Your Eligibility Results",
    subtitle:
      "Once you’ve calculated your eligibility, follow these steps to maximize its potential:",
    eligibilityList: [
      {
        head: "Set a Budget: ",
        info: "Use the eligible loan amount to define the range of expenses your loan can cover.",
      },
      {
        head: "Compare Lenders: ",
        info: "Check interest rates, processing fees, and loan terms from different banks and NBFCs.",
      },
      {
        head: "Optimize Your Profile: ",
        info: "Improve your credit score or reduce existing debts if you need a higher loan amount.",
      },
      {
        head: "Plan for EMIs: ",
        info: "Ensure the EMI fits comfortably within your monthly budget to avoid financial stress.",
      },
    ],
  },
];
export const stepFiveData = [
  {
    heading: "Tips to Improve Your Personal Loan Eligibility",
    subtitle:
      "If your results are not as favorable as you hoped, here are some practical ways to improve your eligibility:",

    improveEligibilityList: [
      {
        head: "Enhance Your Credit Score: ",
        info: "Pay your credit card bills and EMIs on time, reduce outstanding debts, and avoid multiple loan inquiries.",
      },
      {
        head: "Reduce Fixed Obligations: ",
        info: "Clear smaller debts or consolidate loans to free up disposable income.",
      },
      {
        head: "Opt for a Co-Applicant: ",
        info: "Adding a family member with a stable income can significantly boost eligibility.",
      },
      {
        head: "Increase Your Income: ",
        info: "If possible, negotiate a salary hike or show additional income sources like rent or investments.",
      },
      {
        head: "Choose a Longer Tenure: ",
        info: "While this reduces EMI amounts, ensure the overall interest cost remains manageable.",
      },
    ],
  },
];
export const stepSixData = [
  {
    heading: "Why Choose Minemi for Your Personal Loan Needs?",
    subtitle:
      "At Minemi, we’re committed to making personal loans accessible and hassle-free. Our platform not only helps you calculate your eligibility but also offers:",

    needsList: [
      {
        head: "Personalized Recommendations: ",
        info: "Get tailored loan offers from top lenders.",
      },
      {
        head: "Transparency: ",
        info: "No hidden charges or fine print—just clear, actionable insights.",
      },
      {
        head: "Smart Tools: ",
        info: "Use our suite of calculators to plan every aspect of your loan journey.",
      },
    ],
  },
];
